(ns web3.components.widgets
  (:require [reagent.core :as r]
            [web3.view :as v]
            [web3.utils :as utils]
            [web3.components.progress :as progress]
            [web3.routing.core :as routing]
            [web3.env :as env]
            [web3.icons.shapes :as shapes]
            [web3.view.hiccup :as hiccup]
            [web3.icons.actions :as actions]
            [web3.i18n :as i]))

(defn chevron-action [props]
  [:div.flex.items-center.margin-left-3.pad-h-3.hover-opacity-child
   (-> props
       #_(update :style merge {:border-left "2px solid rgba(255,255,255,1)"}))
   (-> shapes/chevron-right
       (hiccup/styles {:color "black"}))])

(defn edit-pencil [props]
  [:a.hover-text-black-hover.cursor-pointer.text-category.round-100p.flex.items-center.justify-center.icon-circle-light.flex-none
   props
   (-> actions/edit-pencil
       (hiccup/size 16))])

(defn edit-pencil-drawer [korks]
   (let [edit? (boolean (routing/get-query korks))
         read-only? (boolean (routing/get-query [:edit :read-only?]))]
     (when-not read-only?
       [:div.icon-circle-light.round-100p.flex.items-center.justify-center.margin-h-3.flex-none
        {:on-click #(routing/set-query! korks (not edit?))
         :class (when edit? "icon--active")}
        actions/edit-pencil])))

(defn black-circle-icon [icon]
  [:div.flex.items-center.justify-center.round-100p.cursor-pointer.text-white.bg-black.shadow-drawer
   {:style {:width 30
            :height 30}}
   icon])

(def zoom-icon [black-circle-icon actions/zoom])


(def primary-button-classes " items-center pad-v-2_5 text-center
                            pad-h-4 text-uppercase weight-bold justify-center
                            text-size-14 line-h-18 nowrap round-3
                            cursor-pointer border-none")
(def black-button-classes " bg-black text-white hover-bg-black-hover")

(defn black-button [{:keys [href] :as props} & content]
  (-> [(or (get props :element)
           (if href :a :div))
       (-> props
           (dissoc :element)
           (->> (merge-with merge {:style {:max-height "42px"}}))
           (update :class str primary-button-classes black-button-classes))]
      (into content)))

(defn primary-button [{:keys [href] :as props} & content]
  (-> [(if href :a :div)
       (update props :class str primary-button-classes)]
      (into content)))

(v/defview html-fetch
  {:get-initial-state (constantly {:loading? true})
   :component-will-mount
   (fn [{{:keys [url]} :props
         state :state}]
     (utils/fetch url
                  {:format :text
                   :parse utils/to-node
                   :on-complete (fn [node]
                                  (swap! state assoc :result node :loading? false))}))}
  [{:keys [url selector]}]
  (let [{:keys [state]} (r/current-component)]
    (if-let [result (:result @state)]
      [:div {:key url
             :dangerouslySetInnerHTML {:__html (.-innerHTML (.querySelectorAll result selector))}}]
      [:div {:key url}])))

(defn graphql-state [{:keys [graphql/loading? graphql/error absolute? negative-pad? style height] :as query-state
                      :or {height 2}}]
  ;; sample loading+error state for testing purposes
  #_[{:keys [loading? error]} {:loading? true
                               :error {:source ::whatever
                                       :thingie "Thing"}}]
  [:div.flex-none
   {:class (str (if (and absolute? (not error))
                  "top-0 left-0 right-0 absolute"
                  "relative")
                (if negative-pad?
                  " margin-left-n3 margin-right-n3 margin-top-n3 margin-bottom-3"
                  " width-100p"))
    :style (merge (when (and (not loading?)
                             (not error))
                    {:height 0})
                  style)}
   [progress/indeterminate (merge {:key "progress"
                                   :height height
                                   :style {:opacity (if loading? 1 0)}
                                   :class "flex-none overflow-hidden"}
                                  (select-keys query-state [:color :bg-color]))]
   (when-let [message (:message error)]
     [:div.pad-all-3.text-red.bg-light-pink message])])

(defn graphql-submit-button [{:keys [label form-loading?]
                              mutation-state :state}]

  (let [mutation-state (assoc mutation-state :graphql/loading?
                                             (or (:graphql/loading? mutation-state)
                                                 form-loading?))
        loading? (:graphql/loading? mutation-state)]
    [:div.margin-top-3.transition-all
     {:style {:opacity (if loading? 0.7 1)}}
     [graphql-state (cond-> mutation-state
                            loading? (assoc
                                       :height 2
                                       :style {:margin-bottom -2
                                               :border-radius "10px 10px 0 0"
                                               :overflow "hidden"}))]
     [:button {:key label
               :disabled loading?
               :type "submit"
               :style (merge {:border "none"
                              :outline 0}
                             (when loading?
                               {:cursor :progress}))
               :class (str black-button-classes
                           primary-button-classes
                           " flex width-100p")}
      label]]))

(def form-card :div.round-4.bg-white.pad-all-3.shadow-card)

(v/defview not-found
  {:allow-public true
   :header {:title (i/get :i/not-found)}}
  []
  [:div.pad-v-4.pad-h-3.text-size-20.text-center
   "Sorry, that page could not be found."])